/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import back from '../assets/images/back.svg'
import { Card } from 'primereact/card'
import { Button } from 'primereact/button'
import { useHistory } from 'react-router-dom'
import { authConstants } from '../_constants'
import { Password } from 'primereact/password'
import { Form } from 'reactstrap'
import { userValidation } from '../_validation'
import PropTypes from 'prop-types'

function SettingsComponent({ settingsEntry, updateUser, checkOldAndNewPassword, justLookingEntry, checkOldAndNewPasswordMaptoolx, getUserById }) {
  const currentUserIdComp = localStorage.getItem(authConstants.USERID)
  const maptoolxFixedId = 4
  const history = useHistory()
  const [backOffice, setBackOffice] = useState({})
  const [profileDetails, setProfileDetails] = useState({})
  const [maptoolx, setMaptoolx] = useState({})
  const [errors, setErrors] = useState({})
  useEffect(() => {
    setBackOffice({
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    }
    )
  }, [settingsEntry])
  useEffect(() => {
    getUserById(currentUserIdComp)
  }, [currentUserIdComp])

  useEffect(() => {
    if (settingsEntry)
      setProfileDetails(settingsEntry)

  }, [settingsEntry])
  function onChangeBackOffice(e) {
    const { name, value } = e.target
    setBackOffice(backOffice => ({ ...backOffice, [name]: value }))
  }
  function onChangeProfileDetails(e) {
    const { name, value } = e.target
    setProfileDetails(profileDetails => ({ ...profileDetails, [name]: value }))
  }
  function onChangeMaptoolx(e) {
    const { name, value } = e.target
    setMaptoolx(maptoolx => ({ ...maptoolx, [name]: value }))
  }

  const redirectBackToPreviousPage = () => {
    history.goBack()
  }

  const resetSettings = (e) => {
    if (e)
      e.preventDefault()

    setErrors(userValidation.mandatoryBackOffice(backOffice))
    if (backOffice.newPassword === backOffice.confirmNewPassword && backOffice.newPassword.trim() !== '' && backOffice.confirmNewPassword.trim() !== '') {
      checkOldAndNewPassword(currentUserIdComp, backOffice.oldPassword, backOffice.newPassword)
    }
  }
  const saveProfileDetails = (e) => {
    if (e)
      e.preventDefault()

    setErrors(userValidation.mandatoryProfileDetails(profileDetails))

    if (profileDetails?.firstName !== null && profileDetails?.firstName.trim() !== '' && profileDetails?.lastName !== null && profileDetails?.lastName.trim() !== '') {
      updateUser(profileDetails, currentUserIdComp)
    }
  }
  const maptoolxSettings = (e) => {
    if (e)
      e.preventDefault()

    setErrors(userValidation.mandatoryMaptoolx(maptoolx))

    if (maptoolx?.maptoolxUserName !== null && maptoolx?.maptoolxOldPassword !== null && maptoolx?.maptoolxNewPassword === maptoolx?.maptoolxConfirmNewPassword) {
      checkOldAndNewPasswordMaptoolx(maptoolxFixedId, maptoolx?.maptoolxUserName, maptoolx?.maptoolxOldPassword, maptoolx?.maptoolxNewPassword)
    }
  }

  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="cardBase addSector">
          <Form >
            <div className="p-grid">
              <div className="p-col-12 titleSec">
                <img src={back} alt={back} className="m-r-10 pointer" onClick={() => redirectBackToPreviousPage()} />
                <h4 className="display_1 m-b-0">Settings</h4>
              </div>
              <div className="p-col-12 titleSec">
                <h4 className="display_1 m-b-0">Back office Password</h4>
              </div>
              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label"> New Password  <sup className="inputHolder--required">*</sup></label>
                  <Password value={backOffice.newPassword ? backOffice.newPassword : ''} name="newPassword" feedback={false} className="inputHolder--inputBox" placeholder="New Password" onChange={onChangeBackOffice} />
                  {errors.newPassword && (
                    <p className='space-danger'>{errors.newPassword}</p>
                  )}
                </span>
              </div>
              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label">Confirm  New Password  <sup className="inputHolder--required">*</sup></label>
                  <Password value={backOffice.confirmNewPassword ? backOffice.confirmNewPassword : ''} name="confirmNewPassword" feedback={false} className="inputHolder--inputBox" placeholder="Confirm New Password" onChange={onChangeBackOffice} />
                  {errors.confirmNewPassword && (
                    <p className='space-danger'>{errors.confirmNewPassword}</p>
                  )}
                </span>
              </div>
              <div className="p-col-12 m-t-10">
                <Button label="Reset" className="p-button-raised p-button-rounded inputHolder--formBtn" onClick={resetSettings} />
              </div>
              <div className="p-col-12 titleSec">
                <h4 className="display_1 m-b-0">Profile details</h4>
              </div>

              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label">First Name  <sup className="inputHolder--required">*</sup></label>
                  <InputText value={profileDetails?.firstName ? profileDetails?.firstName : ''} name="firstName" className="inputHolder--inputBox" placeholder="First Name" onChange={onChangeProfileDetails} maxLength="256" />
                  {errors.firstName && (
                    <p className='space-danger'>{errors.firstName}</p>
                  )}
                </span>
              </div>
              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label">Last Name  <sup className="inputHolder--required">*</sup></label>
                  <InputText name="lastName" value={profileDetails?.lastName ? profileDetails?.lastName : ''} className="inputHolder--inputBox" placeholder="Last Name" onChange={onChangeProfileDetails} maxLength="256" />
                  {errors.lastName && (
                    <p className='space-danger'>{errors.lastName}</p>
                  )}
                </span>
              </div>
              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label">Email Address</label>
                  <InputText name="emailAddress" value={profileDetails?.emailAddress ? profileDetails?.emailAddress : ''} className="inputHolder--inputBox" placeholder="Email Address" onChange={onChangeProfileDetails} readOnly={true} />
                </span>
              </div>
              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label">State</label>
                  <InputText name="state" value={profileDetails?.state ? profileDetails?.state : ''} className="inputHolder--inputBox" placeholder="State" onChange={onChangeProfileDetails} />
                </span>
              </div>
              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label"> Address</label>
                  <InputTextarea rows={10} cols={30} name="address" value={profileDetails?.address ? profileDetails?.address : ''} className="inputHolder--inputBox" placeholder="Address" autoResize={true} onChange={onChangeProfileDetails} />
                </span>
              </div>
              <div className="p-col-12 m-t-10">
                <Button label="Save" className="p-button-raised p-button-rounded inputHolder--formBtn" onClick={saveProfileDetails} />
              </div>
              <div className="p-col-12 titleSec">
                <h4 className="display_1 m-b-0">maptoolx credentials</h4>
              </div>
              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label">Username  <sup className="inputHolder--required">*</sup></label>
                  <InputText name="maptoolxUserName" value={justLookingEntry?.emailAddress ? justLookingEntry?.emailAddress : ''} className="inputHolder--inputBox" placeholder="User Name" onChange={onChangeMaptoolx} maxLength="312" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" />
                  {errors.maptoolxUserName && (
                    <p className='space-danger'>{errors.maptoolxUserName}</p>
                  )}
                </span>
              </div>
              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label">Old Password  <sup className="inputHolder--required">*</sup></label>
                  <Password value={maptoolx?.maptoolxOldPassword ? maptoolx?.maptoolxOldPassword : ''} name="maptoolxOldPassword" feedback={false} className="inputHolder--inputBox" placeholder="Old Password" onChange={onChangeMaptoolx} />
                  {errors.maptoolxOldPassword && (
                    <p className='space-danger'>{errors.maptoolxOldPassword}</p>
                  )}
                </span>
              </div>
              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label">New Password  <sup className="inputHolder--required">*</sup></label>
                  <Password value={maptoolx?.maptoolxNewPassword ? maptoolx?.maptoolxNewPassword : ''} name="maptoolxNewPassword" feedback={false} className="inputHolder--inputBox" placeholder="New Password" onChange={onChangeMaptoolx} />
                  {errors.maptoolxNewPassword && (
                    <p className='space-danger'>{errors.maptoolxNewPassword}</p>
                  )}
                </span>
              </div>
              <div className="p-col-4">
                <span className="inputHolder">
                  <label className="inputHolder--label">Confirm New Password  <sup className="inputHolder--required">*</sup></label>
                  <Password value={maptoolx?.maptoolxConfirmNewPassword ? maptoolx?.maptoolxConfirmNewPassword : ''} name="maptoolxConfirmNewPassword" feedback={false} className="inputHolder--inputBox" placeholder="Confirm New Password" onChange={onChangeMaptoolx} />
                  {errors.maptoolxConfirmNewPassword && (
                    <p className='space-danger'>{errors.maptoolxConfirmNewPassword}</p>
                  )}
                </span>
              </div>
              <div className="p-col-12 m-t-10">
                <Button label="Save" className="p-button-raised p-button-rounded inputHolder--formBtn" onClick={maptoolxSettings} />
              </div>
            </div>
          </Form>
        </Card>
      </div>
    </div >)
}

SettingsComponent.propTypes = {
  settingsEntry: PropTypes.object,
  updateUser: PropTypes.func,
  checkOldAndNewPassword: PropTypes.func,
  justLookingEntry: PropTypes.object,
  checkOldAndNewPasswordMaptoolx: PropTypes.func,
  getUserById: PropTypes.func,
}
export default SettingsComponent
